import {Component, inject, Input, OnInit, ViewChild} from '@angular/core';
import {
  GenericListComponent,
  PageChangeInfo
} from '../../../../../../components/generic/generic-list/generic-list.component';
import {LoadingComponent} from '../../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../../components/generic/message/message.component';
import {PrimeTemplate} from 'primeng/api';
import {ViewService} from '../../../../../shared/service/view.service';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {ErrorType} from '../../../../../../model/error-type';
import {Pagination} from '../../../../../../model/pagination';
import {PagingFilter} from '../../../../../shared/model/paging-filter';
import {MessagesFilter} from '../../../../model/api/MessagesFilter';
import {ColumnType} from '../../../../../../components/generic/generic-list/columnType';
import {Divider} from 'primeng/divider';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DatePipe, NgTemplateOutlet} from '@angular/common';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {
  PlayerProfileMessageDetailComponent
} from './player-profile-message-detail/player-profile-message-detail.component';
import {DialogService} from 'primeng/dynamicdialog';
import {InteractiveHelpComponent} from '../../../../../shared/interactive-help/interactive-help.component';

@Component({
  selector: 'app-player-profile-messages-list',
  imports: [
    GenericListComponent,
    LoadingComponent,
    MessageComponent,
    PrimeTemplate,
    Divider,
    TranslatePipe,
    DatePipe,
    Button,
    NgTemplateOutlet,
    Tooltip,
    InteractiveHelpComponent
  ],
  templateUrl: './player-profile-messages-list.component.html',
  styleUrl: './player-profile-messages-list.component.scss'
})
export class PlayerProfileMessagesListComponent implements OnInit
{
  public view = inject(ViewService);
  public playerProfileService = inject(PlayerProfileService);
  private restErrorHelper = inject(RestErrorHelper);
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);

  @ViewChild('typeTemplate') typeTemplate: any;
  @ViewChild('linksTemplate') linksTemplate: any;
  @ViewChild('textTemplate') textTemplate: any;

  @Input() showDivider: boolean;
  @Input() filterFunctionCd: string;
  @Input() positionTop: number;

  isLoading: boolean;
  errorMsg: ErrorType;
  isPro: boolean;
  deletingMessage: boolean;

  pagedData: Pagination;
  paging: PagingFilter;
  filter: MessagesFilter;

  columns: any[];
  columnsMobile: ColumnType[];
  showDeleteSelected: boolean;

  ngOnInit(): void
  {
    this.isPro = this.playerProfileService.playerAuthenticationService.isProVersion();

    this.paging = {
      pageOffset: 0,
      // pageSize: this.playerSessionService.statisticListPageSize,
      pageSize: 10,
      sortField: 'date',
      sortOrder: -1
    };
    this.filter = {
      functionCd: this.filterFunctionCd
    };

    console.log('Paging', this.paging);
    this.loadData();
  }

  private initColumns(): void
  {
    if (this.columns && this.columnsMobile)
      return;

    this.columns = [
      {
        key: 'DATE', header: 'DATE', field: 'date', datatype: 'datetime', width: '130', class: 'text-center', sortable: true
      },
      {header: 'TYPE', datatype: 'template', width: '40', template: this.typeTemplate, class: 'text-center'},
      {key: 'MSG', header: 'MESSAGE', datatype: 'template', template: this.textTemplate},
      {header: '', datatype: 'template', width: '40', template: this.linksTemplate}
    ];

    this.columnsMobile = [
      {
        key: 'MSG',
        header: 'MESSAGES'
      }
    ];
  }

  public loadData(): void
  {
    console.log('loadData()');
    this.isLoading = true;
    this.playerProfileService.getMessages(this.paging, this.filter).subscribe({
      next: data =>
      {
        console.log('Nachrichten erhalten', data);
        this.initColumns();
        this.pagedData = data;
        this.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  public lazyLoading(pageChangeInfo: PageChangeInfo): void
  {
    console.log('lazyLoading, pageOffset: ' + pageChangeInfo.pageOffset + ', pageSize: ' + pageChangeInfo.pageSize);
    // this.playerSessionService.statisticListPageSize = pageChangeInfo.pageSize;

    if (pageChangeInfo.pageOffset >= 0)
      this.paging.pageOffset = pageChangeInfo.pageOffset;
    this.paging.pageSize = pageChangeInfo.pageSize;

    if (this.paging.sortOrder === -1 || this.paging.sortOrder === 1)
      this.paging.sortOrder = pageChangeInfo.sortOrder;

    this.loadData();
  }

  public onRowSelect(item: any): void
  {
    console.log('Item', item);
    if (item?.data)
      PlayerProfileMessageDetailComponent.showDialog(this.dialogService, item.data, this.translate);
  }

  public openLink(link: string): void
  {
    if (link)
      window.open(link, '_blank');
  }

  public rowDelete(event: any): void
  {
    console.log('rowDelete: ', event);

    this.deletingMessage = true;
    this.playerProfileService.deleteMessage(event.id).subscribe({
      next: data =>
      {
        console.log('Nachricht gelöscht', data);
        this.deletingMessage = false;
        this.loadData();
      },
      error: error =>
      {
        this.deletingMessage = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }
}
